import axios from 'axios';
const welcome = {
  namespaced: true,
  state() {
    return {
      home: {
        currently: 0,
        fr: {
          text: [
            'Nous sommes ouvert tous les jours',
            'Ouverture été 2026',
            'Ouverture le 29 mai 2026',
          ],
          btn: 'Découvrir',
        },
        en: {
          text: [
            'We are opened everyday',
            'Opening summer 2026',
            'Opening may 28 2026',
          ],
          btn: 'Discover',
        },
        ar: {
          text: ['مفتوح يوميا', 'الافتتاح صيف 2026', 'الافتتاح 28 ماي 2026'],
          btn: 'اكتشف',
        },
      },
      pricesDate: '2026',
      prices: {
        fr: [
          {
            id: 0,
            name: 'Adultes',
            price: 60,
            imgUrl: require('@/assets/_K8A7963.jpeg'),
            icos: ` <i class="fas fa-female"></i>
          <i class="fas fa-male"></i>`,
            heights: {
              min: '+1.40m',
              max: '',
            },
          },
          {
            id: 1,
            name: 'Enfants',
            price: 50,
            imgUrl: require('@/assets/DSC_9881.jpeg'),
            icos: `<i class="fas fa-child"></i>`,
            heights: {
              min: '0.80m',
              max: '1.40m',
            },
          },
          {
            id: 2,
            name: 'Bébés',
            price: 'Gratuit',
            imgUrl: require('@/assets/baby-girl.jpeg'),
            icos: `<i class="fas fa-baby"></i>`,
            heights: {
              min: '',
              max: '0.80m',
            },
          },
        ],
        en: [
          {
            id: 0,
            name: 'Adults',
            price: 60,
            imgUrl: require('@/assets/_K8A7963.jpeg'),
            icos: ` <i class="fas fa-female"></i>
          <i class="fas fa-male"></i>`,
            heights: {
              min: '+1.40m',
              max: '',
            },
          },
          {
            id: 1,
            name: 'Kids',
            price: 50,
            imgUrl: require('@/assets/DSC_9881.jpeg'),
            icos: `<i class="fas fa-child"></i>`,
            heights: {
              min: '0.80m',
              max: '1.40m',
            },
          },
          {
            id: 2,
            name: 'Babies',
            price: 'Free',
            imgUrl: require('@/assets/baby-girl.jpeg'),
            icos: `<i class="fas fa-baby"></i>`,
            heights: {
              min: '',
              max: '0.80m',
            },
          },
        ],
        ar: [
          {
            id: 0,
            name: 'الكبار',
            price: 60,
            imgUrl: require('@/assets/_K8A7963.jpeg'),
            icos: ` <i class="fas fa-female"></i>
          <i class="fas fa-male"></i>`,
            heights: {
              min: '+1.40م',
              max: '',
            },
          },
          {
            id: 1,
            name: 'الأطفال',
            price: 50,
            imgUrl: require('@/assets/DSC_9881.jpeg'),
            icos: `<i class="fas fa-child"></i>`,
            heights: {
              min: '0.80م',
              max: '1.40م',
            },
          },
          {
            id: 2,
            name: 'الرضّع',
            price: 'مجاني',
            imgUrl: require('@/assets/baby-girl.jpeg'),
            icos: `<i class="fas fa-baby"></i>`,
            heights: {
              min: '',
              max: '0.80m',
            },
          },
        ],
      },
      pricesText: {
        fr: {
          text: 'Les Tarifs/Tickets 2026',
          currency: 'DT/jour',
        },

        en: {
          text: '2026 ticket prices',
          currency: 'TD/day',
        },
        ar: {
          text: 'الأسعار/تذاكر 2026',
          currency: 'د.ت / يوم',
        },
      },
      status: {
        fr: ['Ouvert', 'Fermé'],
        en: ['Open', 'Closed'],
        ar: ['مفتوح', 'مغلق'],
      },
      statusText: {
        fr: [
          'Ouvert de 9h30 à 17h30',
          "Ouverture l'été prochain",
          'Ouverture le 29 mai 2026',
        ],
        en: [
          'Opened from 9:30AM to 5:30PM',
          'Opening next summer',
          'Opening may 29th 2026',
        ],
        ar: [
          'مفتوح من 9:30 الى 17:30',
          'الافتتاح في الصيف المقبل',
          'الافتتاح 29 ماي 2026',
        ],
      },
      opDate: [2026, 4, 29],
      clDate: [2026, 8, 20],
    };
  },
  mutations: {
    setStatus(state, value) {
      state.status = value;
    },
    setPrices(state, value) {
      state.prices = value;
    },
  },
  getters: {
    getPrices(state, getters, rootState, rootGetters) {
      return state.prices[rootGetters['lang/getCurrentLang']];
    },
    getPricesText(state, getters, rootState, rootGetters) {
      return state.pricesText[rootGetters['lang/getCurrentLang']];
    },
    getStatus(state, getters, rootState, rootGetters) {
      return state.status[rootGetters['lang/getCurrentLang']];
    },
    getStatusText(state, getters, rootState, rootGetters) {
      return state.statusText[rootGetters['lang/getCurrentLang']];
    },
    getHome(state, getters, rootState, rootGetters) {
      return state.home[rootGetters['lang/getCurrentLang']];
    },
  },
  actions: {
    getStatus({ state, commit, rootGetters }) {
      if (state.status === null) {
        axios
          .post('/lienVersDonnée', {
            currentLang: rootGetters['lang/getCurrentLang'],
          })
          /*
          retourne status : "Etat deja traduit depuis la base"
        */
          .then((response) => {
            // dans la reponse on doit avoir status qui changera la valeur actuelle.
            commit('setStatus', response.status);
          })
          .catch((response) => {
            console.log(response);
          });
      }
    },
    getPrices({ state, commit, rootGetters }) {
      if (state.price === null) {
        axios
          .post('/lienVersDonnée', {
            currentLang: rootGetters['lang/getCurrentLang'],
            /*
          retourne status : "Etat deja traduit depuis la base"
        */
          })
          .then((response) => {
            // dans la reponse on doit avoir status qui changera la valeur actuelle.
            commit('setPrices', response.prices);
          })
          .catch((response) => {
            console.log(response);
          });
      }
    },
  },
};
export default welcome;
